module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Underworld-Awakening.4e6c2a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Underworld-Awakening.jpg
// module id = ZGTu
// module chunks = 0